<template>
  <v-card elevation="0">
    <v-card-text>
      <v-row>
        <h3>{{ $t("legend") }}:</h3>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-list-item>
            <v-chip class="legendChips" small label color="primary lighten-2" />
            <v-list-item-content>
              <strong>{{ $t("agenda.LegendChip1") }}</strong>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-list-item>
            <v-chip class="legendChips" small label color="success" />
            <v-list-item-content>
              <strong>{{ $t("agenda.LegendChip2") }}</strong>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-list-item>
            <v-chip class="legendChips" small label color="warning" />
            <v-list-item-content>
              <strong>{{ $t("agenda.LegendChip3") }}</strong>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-list-item>
            <v-chip class="legendChips" small label color="orange" />
            <v-list-item-content>
              <strong>{{ $t("agenda.LegendChip4") }}</strong>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-list-item>
            <v-chip class="legendChips" small label color="error" />
            <v-list-item-content>
              <strong>{{ $t("agenda.LegendChip5") }}</strong>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-list-item>
            <v-chip class="legendChips" small label color="warning darken-1" />
            <v-list-item-content>
              <strong>{{ $t("agenda.LegendChip6") }}</strong>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>

      <v-divider v-if="!isMobile"></v-divider>
      <v-row style="height: 42px" v-if="!isMobile">
        <v-col cols="12" sm="12" md="1" lg="1"> </v-col>
        <v-col cols="12" sm="12" md="7" lg="7">
          <v-toolbar flat tile>
            <v-avatar size="35px" dark></v-avatar>
            <v-icon color="secondary darken-1">mdi-arrow-down-bold</v-icon
            ><strong>{{ $t("agenda.lblStartTime") }}</strong>
            <v-spacer></v-spacer>
            <strong>{{ $t("agenda.lblEndTime") }}</strong>
            <v-icon color="secondary darken-1">mdi-arrow-down-bold</v-icon>
          </v-toolbar>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" align="left">
          <v-toolbar flat tile
            ><strong
              ><span class="timeHeader">{{ $t("Time") }}</span> |
              <span class="timeHeader">{{ $t("ElapsedTime") }}</span>
            </strong></v-toolbar
          >
        </v-col>
        <v-col cols="12" sm="2" md="1" lg="1"> </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12">
          <h3>{{ $t("Meeting") }}</h3>
          <v-divider></v-divider>
        </v-col>
      </v-row>
      <MeetingTimer
        v-if="meetingObj"
        :topicObject="meetingObj"
        :isMeetingStarted="isMeetingStarted"
        @getMeetingTimerData="getMeetingTimerData"
        @startStop="onStartStop"
        @resetMeetingTimer="ConfirmTimerReset"
      ></MeetingTimer>
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12">
          <h3>{{ $t("Topics") }}</h3>
          <v-divider></v-divider>
        </v-col>
      </v-row>
      <MeetingTimer
        v-for="topic in topicArray"
        :key="topic.index"
        :topicObject="topic"
        :isMeetingStarted="isMeetingStarted"
        @onTopicTimerStatusChanged="onTopicTimerStatusChanged"
        @onSyncTopicTimerData="syncTopicTimerData"
        :previousTimerObj="previousTimerObj"
        @startStop="onTopicStartStop"
        @onChangeTopicStatus="updateTopicSkipedStatus"
      >
      </MeetingTimer>
    </v-card-text>
    <ConfirmDlg ref="confirm" />
  </v-card>
</template>
<script>
import MeetingTimer from "@/components/agenda/MeetingTimer.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import ConfirmDlg from "@/components/ConfirmDialog.vue";
import _ from "lodash";
export default {
  name: "MeetingTimerChart",
  data() {
    return {
      currentMeeting: {},
      meetingTimerValue: 0,
      meetingObj: null,
      isMeetingStarted: false,
      previousTimerObj: null,
      topicArray: [],
      topicObject: {
        starttime: "",
        endtime: "",
        actualtime: "",
        elapsed: "",
        remaining: "",
        status: "",
        lessTimeWarning: false,
        timerValue: "",
        topicText: "",
        timeCounter: 0,
        isMeetingTimer: false,
        topicId: null,
      },
      topicCategories: [],
      catTopics: [],
    };
  },
  props: {
    selectedMeeting: Object,
  },
  components: {
    MeetingTimer,
    ConfirmDlg,
  },
  async created() {
    this.currentMeeting = this.selectedMeeting;
    this.meetingObj = this.getMeetingProgressObject();
    await this.getTenantConfigList();
    this.topicArray = this.generateTimerObjectArray();
  },
  computed: {
    ...gettersMap(),
    categorizedTopics: {
      get() {
        this.catTopics = this.tenantSettingTypes("topiccategory").map(
          (item) => ({
            ...item,
            order: this.getTopicOrder(item),
            topics: this.currentMeeting.topics
              .filter((s) => s.topicCategory === item.id)
              .sort((a, b) => a.displayOrder - b.displayOrder),
          })
        );
        return this.catTopics.sort((a, b) => a.order - b.order);
      },
      set(val) {
        this.catTopics = val;
      },
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    meetingDuration() {
      let start = new Date(this.currentMeeting.scheduletStartTimeInUTC);
      let end = new Date(this.currentMeeting.scheduledEndTimeInUTC);
      var timeDiff = end - start;
      return timeDiff / 60 / 1000;
    },
  },
  methods: {
    getTopicOrder(item) {
      if (!this.currentMeeting.topicCategories) {
        return item.order;
      }

      let cat = this.currentMeeting.topicCategories.find(
        (f) => f.value === item.value
      );
      if (cat) {
        return cat.order;
      }

      return item.order;
    },
    ...mapActions({
      getTenantConfigList: "tenant/getTenantConfigList",
      updateMeetingData: "meeting/updateMeeting",
      getMeetingDetails: "meeting/getMeetingById",
    }),
    syncTopicTimerData(obj) {
      obj.lessTimeWarning = this.topicTimeFeasibilityCheck(obj);
      this.topicArray[obj.index] = Object.assign({}, obj);
    },
    topicTimeFeasibilityCheck(obj) {
      if (obj.status === "NotStarted") {
        if (this.meetingObj.remaining < obj.actualtime) {
          return true;
        } else {
          return false;
        }
      }
    },
    finishRunningTopic(newIndex) {
      let prevTimer = this.topicArray.find(
        (p) => p.index != newIndex && p.status === "Started"
      );
      if (prevTimer) {
        prevTimer.status = "Finished";
        prevTimer.endtime = new Date().toISOString();
        this.previousTimerObj = Object.assign({}, prevTimer);
        this.topicArray[prevTimer.index] = Object.assign({}, prevTimer);
      }
    },
    onTopicTimerStatusChanged(obj) {
      if (obj.status == "Started") {
        this.finishRunningTopic(obj.index);
      }
      this.topicArray[obj.index] = Object.assign({}, obj);
    },
    generateTimerObjectArray() {
      let topicArr = [];

      this.categorizedTopics.forEach((cat) => {
        cat.topics
          .sort((a, b) => a.displayOrder - b.displayOrder)
          .forEach((topic) => {
            let topicObj = Object.assign({}, this.topicObject);
            topicObj.starttime = "-";
            topicObj.endtime = "-";
            topicObj.actualtime = topic.timeInMinutes;
            topicObj.topicText = topic.topicName;
            topicObj.status = "NotStarted";
            topicObj.elapsed = 0;
            topicObj.remaining = topic.timeInMinutes;
            topicObj.endtime = topic.endtime || null;
            topicObj.starttime = topic.starttime || null;
            topicObj.timerValue = topic.timerValue || null;
            topicObj.timeCounter = topic.timeCounter || null;
            topicObj.elapsed = topic.elapsed || null;
            topicObj.status = topic.status || null;
            topicObj.isMeetingTimer = false;
            topicArr.push(topicObj);
          });
      });

      return topicArr.map((item, index) => ({
        index: index,
        ...item,
      }));
    },
    getMeetingProgressObject() {
      let meetingObj = Object.assign({}, this.topicObject);
      meetingObj.starttime = this.currentMeeting.scheduletStartTimeInUTC;
      meetingObj.endtime = this.currentMeeting.scheduledEndTimeInUTC;
      meetingObj.actualtime = this.meetingDuration; //Calculate this later
      meetingObj.isMeetingTimer = true;
      meetingObj.elapsed = 0;
      meetingObj.remaining = this.meetingDuration;
      meetingObj.topicText = this.currentMeeting.meetingName;
      meetingObj.startMeetingTime =
        this.currentMeeting.startMeetingTime || null;
      meetingObj.endMeetingTime = this.currentMeeting.endMeetingTime || null;
      meetingObj.timerValue = this.currentMeeting.timerValue || null;
      meetingObj.elapsed = this.currentMeeting.elapsed || null;
      meetingObj.timeCounter = this.currentMeeting.timeCounter || null;
      meetingObj.status = this.currentMeeting.status || null;
      meetingObj.topics = this.currentMeeting.topics || [];
      return meetingObj;
    },

    getMeetingTimerData(obj, isMeetingStarted) {
      this.meetingObj = Object.assign({}, obj);
      if (!isMeetingStarted) {
        this.finishRunningTopic(-1);
      }
      this.isMeetingStarted = isMeetingStarted;
    },
    async onStartStop(obj, isMeetingStarted) {
      if (isMeetingStarted) {
        await this.updateMeetingDetails(obj);
        this.updateMeetingData(this.currentMeeting);
        this.onTopicStartStop(obj);
      }
    },
    async onTopicStartStop(obj, isMeetingStarted = false) {
      if (this.previousTimerObj) {
        await this.updateMeetingDetails(obj);
        const topic = this.currentMeeting.topics.find(
          (t) => t.topicName === this.previousTimerObj.topicText
        );
        const updatedTopic = this.topicArray.find(
          (t) => t.topicText === this.previousTimerObj.topicText
        );
        topic.endtime = updatedTopic.endtime;
        topic.starttime = updatedTopic.starttime;
        topic.timerValue = updatedTopic.timerValue;
        topic.timeCounter = updatedTopic.timeCounter;
        topic.elapsed = updatedTopic.elapsed;
        topic.status = updatedTopic.status;
        this.updateMeetingData(this.currentMeeting);
      }
    },
    async updateTopicSkipedStatus(obj) {
      await this.updateMeetingDetails(obj);
      const topic = this.currentMeeting.topics.find(
        (t) => t.topicName === obj.topicText
      );
      topic.status = obj.status;
      this.updateMeetingData(this.currentMeeting);
    },
    async updateMeetingDetails(obj) {
      this.currentMeeting = await this.getMeetingDetails(
        this.currentMeeting.id
      );
      this.meetingObj = Object.assign({}, obj);
      this.currentMeeting.startMeetingTime =
        this.meetingObj.startMeetingTime || null;
      this.currentMeeting.endMeetingTime =
        this.meetingObj.endMeetingTime || null;
      this.currentMeeting.timerValue = this.meetingObj.timerValue || null;
      this.currentMeeting.timeCounter = this.meetingObj.timeCounter;
      this.currentMeeting.elapsed = this.meetingObj.elapsed;
      this.currentMeeting.status = this.meetingObj.status;
    },

    resetMeetingObject() {
      this.topicObject = {
        starttime: "",
        endtime: "",
        actualtime: "",
        elapsed: "",
        remaining: "",
        status: "",
        lessTimeWarning: false,
        timerValue: "",
        topicText: "",
        timeCounter: 0,
        isMeetingTimer: false,
        topicId: null,
      };
      let meetingObj = Object.assign({}, this.topicObject);
      this.previousTimerObj = null;
      meetingObj.starttime = this.currentMeeting.scheduletStartTimeInUTC;
      meetingObj.endtime = this.currentMeeting.scheduledEndTimeInUTC;
      meetingObj.actualtime = this.meetingDuration; //Calculate this later
      // meetingObj.isMeetingTimer = true;
      meetingObj.elapsed = 0;
      meetingObj.remaining = this.meetingDuration;
      meetingObj.topicText = this.currentMeeting.meetingName;
      meetingObj.startMeetingTime = null;
      meetingObj.endMeetingTime = null;
      meetingObj.timerValue = null;
      meetingObj.elapsed = null;
      meetingObj.timeCounter = null;
      meetingObj.status = null;
      meetingObj.topics = this.currentMeeting.topics || [];
      return meetingObj;
    },

    async ConfirmTimerReset() {
      if (
        await this.$refs.confirm.open(
          this.$t("agenda.timerReset"),
          this.$t("agenda.timerResetMessage"),
          { yesNoButtons: true }
        )
      ) {
        this.resetMeetingTimer();
      }
    },

    async resetMeetingTimer() {
      this.meetingObj = this.resetMeetingObject();
      await this.updateMeetingDetails(this.meetingObj);
      this.currentMeeting.topics.forEach((topic) => {
        topic.endtime = null;
        topic.starttime = null;
        topic.timerValue = null;
        topic.timeCounter = null;
        topic.elapsed = null;
        topic.status = "";
      });
      this.updateMeetingData(this.currentMeeting);
      this.meetingObj = this.getMeetingProgressObject();
      this.$root.$emit("refresh-timer", this.meetingObj);
      this.topicArray = this.generateTimerObjectArray();
    },
  },
};
function gettersMap() {
  return mapGetters({
    tenantSettingTypes: "tenant/tenantSettingTypes",
  });
}
</script>
<style scoped>
::v-deep .timeHeader {
  width: 100px;
  padding: 0px 0px;
}

::v-deep .legendChips {
  margin: 0px 10px;
}
</style>